import React from 'react';

export const locationContext = React.createContext();

export const LocationProvider = locationContext.Provider;
